import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/inventario_materiales/getComprasRecientesMaterialByUnidad.php';

export default function getComprasRecientesMaterialByUnidad({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}